(function() {
  if (typeof window.CustomEvent === "function") return false;
  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: null };
    var evt = document.createEvent("CustomEvent");
    evt.initCustomEvent(
      event,
      params.bubbles,
      params.cancelable,
      params.detail
    );
    return evt;
  }
  window.CustomEvent = CustomEvent;
})();

import Vue from "vue";

import router from "./router";
import store from "./store";
import App from "./App.vue";

import VueYoutube from "vue-youtube";

import trackingPlugin from "./trackingPlugin";
Vue.use(trackingPlugin, {
  scriptUrl: process.env.VUE_APP_TRACKING_SCRIPT,
  defaultTrackObject: {
    page: {
      // name: "rewe-de:feuerwerk2025:start", // remove to not track initial load
      type: "contentpage",
      channel: "feuerwerk2025",
      hierarchy: ["rewe-de", "feuerwerk2025"],
      campaign: "feuerwerk2025",
      context: "website",
    },
  },
  defaultName: "rewe-de:feuerwerk2025",
  defaultHierarchy: ["rewe-de", "feuerwerk2025"],
  defaultCampaign: "feuerwerk2025",
});

var vueSmoothScroll = require("vue-smoothscroll");
Vue.use(vueSmoothScroll);

import VueMeta from "vue-meta";
Vue.use(VueMeta);

const VueCookie = require("vue-cookie");
Vue.use(VueCookie);

import { VueMasonryPlugin } from "vue-masonry";
Vue.use(VueMasonryPlugin);

Vue.config.productionTip = false;

Vue.filter("floatWithTwoDecimals", function(value) {
  return parseFloat(value)
    .toFixed(2)
    .replace(".", ",");
});

Vue.filter("nl2br", function(value) {
  if (value) {
    return value.replace(/(?:\r\n|\r|\n)/g, "<br>");
  } else {
    return "";
  }
});

Vue.filter("formatInt", function(value) {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
});

Vue.mixin({
  methods: {
    $l(key) {
      return store.state.copies[key] || "";
    },
  },
});

Vue.use(VueYoutube);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
